import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'

function MonthCell({month, isActive, monthChanged, isMarked}) {
  let classes = 'monthpicker__month'
  if (isActive) {
    classes += ' active'
  }

  if (isMarked && !isActive) {
    classes += ' marked'
  }

  return (
    <div
      key={month}
      className={classes}
      onClick={() => monthChanged(month)}
      onKeyPress={() => {}}
      role="button"
      tabIndex={0}>
      <div className="background" />
      <div className="content">{i18n.t(`monthpicker_monthnames_${month}`)}</div>
    </div>
  )
}

MonthCell.propTypes = {
  isActive: PropTypes.bool,
  isMarked: PropTypes.bool,
  month: PropTypes.number,
  monthChanged: PropTypes.func,
}

export default MonthCell
